import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SharedModule } from "../../shared/shared.module";
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxSliderModule } from 'ngx-slider-v2';
import { GalleryModule } from '@ks89/angular-modal-gallery';

import { PubRoutingModule } from './pub-routing.module';
import { dashboardComponent } from './dashboard/dash-component';
import { pubprofileComponent } from './myProfile/profile-component';
import { paymentsComponent } from './payments/payments-component';
import { offersComponent } from './offers/offers-component';
import { offerDetailsComponent } from './offers/offer-details/offer-details-component';
import { fileListComponent } from './lockers/files/files-list';
import { contentsComponent } from './lockers/content/content-component';
import { contentNewComponent } from './lockers/content-new/content-new';
import { contentEditComponent } from './lockers/content-edit/content-edit';
import { conversionsComponent } from './analytics/conversions/conv-component';
// import { contentsComponent } from './analytics/contents/contents-component';
// import { analCountriesComponent } from './analytics/countries/count-component';
import { analworldmapComponent } from './analytics/liveview/worldmap';
import { analyticsComponent } from './analytics/analytics/analytics';


@NgModule({
  declarations: [
    dashboardComponent,
    pubprofileComponent,
    offersComponent,
    offerDetailsComponent,
    analyticsComponent,
    conversionsComponent,
    analworldmapComponent,
    paymentsComponent,
    contentsComponent,
    contentEditComponent,
    contentNewComponent,
    fileListComponent
   ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    NgxSliderModule,
    NgbModule,
    NgMultiSelectDropDownModule.forRoot(),
    SharedModule,
    PubRoutingModule,
    GalleryModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
  ]
})
export class PublisherModule { }
